//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {_getAddressForm, _getDeliveryForm} from "~/helpers/body-submit-new-cart";

export default {
  data: function () {
    return {
      initStagesType: [
        {stage: 1, label: "Тип сертификата", types: ['', 'online', 'pickup']},
        {stage: 2, label: "Дизайн", types: ['', 'online', 'pickup']},
        {stage: 3, label: "Сумма", types: ['', 'online', 'pickup']},
        {stage: 4, label: "Получатель", types: ['', 'online', 'pickup']},
        {stage: 5, label: "Доставка", types: ['', 'pickup']},
      ],
      initStagesNoType: [
        // {stage: 1, label: "Тип сертификата", types: ['', 'online', 'pickup']},
        {stage: 1, label: "Дизайн", types: ['', 'online', 'pickup']},
        {stage: 2, label: "Сумма", types: ['', 'online', 'pickup']},
        {stage: 3, label: "Получатель", types: ['', 'online', 'pickup']},
        {stage: 4, label: "Доставка", types: ['', 'pickup']},
      ],
      types: [
        {value: "online", label: "Электронный", image: require('~/assets/png/sertifikaty/type-digital.png')},
        {value: "pickup", label: "Бумажный", image: require('~/assets/png/sertifikaty/type-paper.png')},
      ],
      templates: [],

      form: {
        type: Boolean(this.useTypeCertificate) ? "" : "online",
        template: "",
        amount: "",
        paymentId: "",
        userInfo: {
          receiverName: "",
          receiverEmail: "",
          congratulationText: "",
          signatureFrom: "",
          payerName: "",
          payerEmail: "",
          payerPhone: "",
        }
      },
      activeStage: 1,
      maxStageStage: 1,
      stage: 0,

      isRegistration: false,
      isRepeatSendFormAfterAuthorization: false,

      methodSendRecaptcha: null
    }
  },

  props: {
    useTypeCertificate: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    rootClassesStages: function () {
      if (this.useTypeCertificate) {
        return {
          '--stage-1': Boolean(this.activeStage === 1),
          '--stage-2': Boolean(this.activeStage === 2),
          '--stage-3': Boolean(this.activeStage === 3),
          '--stage-4': Boolean(this.activeStage === 4),
          '--stage-5': Boolean(this.activeStage === 5),
          '--stage-6': Boolean(this.activeStage === 6),
          '--stage-7': Boolean(this.activeStage === 7),
        }
      }
      return {
        '--stage-1': Boolean(this.activeStage === 0),
        '--stage-2': Boolean(this.activeStage === 1),
        '--stage-3': Boolean(this.activeStage === 2),
        '--stage-4': Boolean(this.activeStage === 3),
        '--stage-5': Boolean(this.activeStage === 4),
        '--stage-6': Boolean(this.activeStage === 5),
        '--stage-7': Boolean(this.activeStage === 6),
      }
    },

    stages: function () {
      const _types = Boolean(this.useTypeCertificate) ? this.initStagesType : this.initStagesNoType;
      return _types.filter((t) => t.types.includes(this.form.type))
    },

    user: function () {
      return this.$store.state?.user?.user || {}
    },
    isGuest: function () {
      return Object.keys(this.$store.state.user?.user || {}).length <= 0
    },
    isRecaptcha: function () {
      return Boolean(Number.parseFloat(this.$store?.state?.appState?.config?.useReCaptchaForAuth || 0))
    },
  },

  components: {
    Navigation: () => import("~/components/sertifikaty/Navigation.vue"),
    PopUpSelectAddress: () => import("~/components/cart-new/PopUpSelectAddress"),
    PopUpEnterCode: () => import("~/components/profile/CertificatesBuy/PopUpEnterCode.vue"),

    // Стадии формы заполенения
    FormType: () => import("~/components/sertifikaty/FormType.vue"),
    FormUsers: () => import("~/components/sertifikaty/FormUsers.vue"),
    FormDesign: () => import("~/components/sertifikaty/FormDesign.vue"),
    FormAmount: () => import("~/components/sertifikaty/FormAmount.vue"),
    PaymentSelect: () => import("~/components/sertifikaty/PaymentSelect.vue"),
    DeliverySelect: () => import("~/components/sertifikaty/DeliverySelect.vue"),
    ConfirmPayment: () => import("~/components/sertifikaty/ConfirmPayment.vue"),
    DialogRecaptcha: () => import("~/components/sertifikaty/DialogRecaptcha.vue"),
  },

  watch: {
    user: async function () {
      await this.checkUser();
    },
  },

  mounted: async function () {
    await this.getTemplates();
    await this.checkUser();
  },

  methods: {
    // Получение шаблонов сертификаторв
    getTemplates: async function () {
      const templates = await this.$api.agent.transport.get("/template").then((res) => {
        return res.data
      }).catch(() => {
        return []
      });
      this.templates = templates;
    },

    checkUser: function () {
      if (this.isGuest) {
        return
      }

      let form = {...this.form};
      form.userInfo.payerName = Boolean(this.user?.name === this.user?.phone) ? "" : this.user?.name;
      form.userInfo.payerEmail = this.user?.email || "";
      form.userInfo.payerPhone = this.user?.phone || "";
      this.form = form;
    },

    nextStage: async function () {
      let newStage = this.activeStage + 1;
      if (newStage === 5 && this.form.type === 'online') {
        await this.getCheckoutData();
        newStage = newStage + 1;
      }
      if (newStage === 5 && this.form.type === 'pickup') {
        await this.getPickupInfo();
        this.activeStage = newStage;
        this.maxStageStage = newStage;
        return
      }

      this.activeStage = newStage;
      this.maxStageStage = newStage;
    },
    changeStage: function (stage) {
      this.activeStage = stage;
    },

    createOrderCertificate: async function () {
      if (Object.keys(this.user || {}).length <= 0) {
        await this.submitFormAuthReg();
        return
      }

      await this.$store.commit('local-settings/setShowDialogLoading', true);

      // Очищаем корзину
      await this.$api.agent.transport.delete('/cart');

      // Добавлем товар сертификата в корзину
      await this.$api.agent.transport.post('/cart', {
        product_id: process.env.certificatProductId,
        quantity: 1,
        data: [
          {
            "type": Boolean(this.form.type === 'online') ? 1 : 2,
            "receiver_name": this.form.userInfo.receiverName,
            "receiver_email": this.form.userInfo.receiverEmail || null,
            "receiver_phone": null,
            "receiver_address": null,
            "from_name": this.form?.userInfo?.signatureFrom || null,

            "amount": parseInt(String(this.form.amount || '').replace(/\D+/g,"")),
            "template_id": this.form.template,
            "comment": this.form.userInfo.congratulationText,
            "email": this.form.userInfo.payerEmail,
          }
        ]
      });

      // Оформление заказа
      const note = [
        Boolean(this.form.userInfo.receiverEmail) && `Почта получателя: ${this.form.userInfo.receiverEmail}`,
        Boolean(this.form.userInfo.receiverName) && `Имя получателя: ${this.form.userInfo.receiverName}`,
        Boolean(this.form.userInfo.signatureFrom) && `Подпись отправителя: ${this.form.userInfo.signatureFrom}`,
      ].filter((t) => !!t).join("; <br/>");
      const appState = this.$store.state?.appState;
      const deliveryForm = await _getDeliveryForm(this.$store.state["cart-new"], appState);
      const addressForm = await _getAddressForm(this.$store.state["cart-new"], appState);
      const responseCheckoutSubmit = await this.$api.agent.transport.post("/checkout/submit", {
        note,

        "CustomerForm": {
          "name": this.form.userInfo.payerName || (this.form.userInfo.payerPhone || '').replace(/\D+/g,""),
          "phone": (this.form.userInfo.payerPhone || '').replace(/\D+/g,""),
          "email": this.form.userInfo.payerEmail || "",
          "legal_type": 1
        },
        "PaymentForm": {
          "id": this.form.paymentId
        },
        ...deliveryForm,
        ...addressForm,
      }).then((res) => {
        return res.data
      }).catch(() => {
        return null
      });
      if (!responseCheckoutSubmit?.hash) {
        this.$store.commit('local-settings/setShowDialogLoading', false);
        this.$toast.error("Ошибка оформления сертификата, повторите попытку позднее.");

        return
      }

      // Получение ссылка на оплату
      const responseLinkPayment = await this.$api.agent.transport.post(`/checkout/pay/${ responseCheckoutSubmit?.hash }`).then((res) => {
        return res.data
      }).catch(() => {
        return null
      })
      if (!responseLinkPayment) {
        this.$store.commit('local-settings/setShowDialogLoading', false);
        this.$toast.error("Не удалось получить ссылку на оплату, повторите попытку позднее.");

        return
      }

      this.$store.commit('local-settings/setShowDialogLoading', false);
      window.location.href = responseLinkPayment;
    },

    getPickupInfo: async function () {
      await this.$store.commit('local-settings/setShowDialogLoading', true);

      // Очищаем корзину
      await this.$api.agent.transport.delete('/cart');

      // Добавлем товар сертификата в корзину
      await this.$api.agent.transport.post('/cart', {
        product_id: process.env.certificatProductId,
        quantity: 1,
        data: [
          {
            "type": Boolean(this.form.type === 'online') ? 1 : 2,
            "receiver_name": this.form.userInfo.receiverName,
            "receiver_email": this.form.userInfo.receiverEmail || null,
            "receiver_phone": null,
            "receiver_address": null,
            "from_name": this.form?.userInfo?.signatureFrom || null,

            "amount": parseInt(String(this.form.amount || '').replace(/\D+/g,"")),
            "template_id": this.form.template,
            "comment": this.form.userInfo.congratulationText,
            "email": this.form.userInfo.payerEmail,
          }
        ]
      });

      await this.$store.dispatch("cart-new/getCheckoutData");
      await this.$store.dispatch("cart-new/getPickupPoints");
      await this.$store.commit("cart-new/changeOpenPopUpSelectAddress", true);

      await this.$store.commit('local-settings/setShowDialogLoading', false);
    },
    getCheckoutData: async function () {
      await this.$store.commit('local-settings/setShowDialogLoading', true);

      // Очищаем корзину
      await this.$api.agent.transport.delete('/cart');

      // Добавлем товар сертификата в корзину
      await this.$api.agent.transport.post('/cart', {
        product_id: process.env.certificatProductId,
        quantity: 1,
        data: [
          {
            "type": Boolean(this.form.type === 'online') ? 1 : 2,
            "receiver_name": this.form.userInfo.receiverName,
            "receiver_email": this.form.userInfo.receiverEmail || null,
            "receiver_phone": null,
            "receiver_address": null,
            "from_name": this.form?.userInfo?.signatureFrom || null,

            "amount": parseInt(String(this.form.amount || '').replace(/\D+/g,"")),
            "template_id": this.form.template,
            "comment": this.form.userInfo.congratulationText,
            "email": this.form.userInfo.payerEmail,
          }
        ]
      });

      await this.$store.dispatch("cart-new/getCheckoutData");

      await this.$store.commit('local-settings/setShowDialogLoading', false);
    },





    // Логика прохода цепочек авторизации / регистрации
    submitFormAuthReg: async function () {
      this.$store.commit("local-settings/setShowDialogLoading", true);
      if (this.stage === 1 && !this.isRegistration) {
        await this._usersLogin();
      }
      if (this.stage === 1 && this.isRegistration) {
        await this._usersConfirmPhone();
      }
      if (this.stage === 0) {
        await this._usersRequest();
      }
      this.$store.commit("local-settings/setShowDialogLoading", false);
    },
    _usersRequest: async function (codeRecaptcha = '') {
      const body = {
        username: parseInt(this.form.userInfo.payerPhone.replace(/[^\d]/g, ''))
      };
      if (this.isRecaptcha && !codeRecaptcha) {
        this.methodSendRecaptcha = this._usersRequest.bind(null)
        return
      }
      if (this.isRecaptcha && codeRecaptcha) {
        this.methodSendRecaptcha = null;
        body['g-recaptcha-response'] = codeRecaptcha;
      }

      const response = await this.$api.agent.transport.post("/users/request", body).then((res) => {
        return res.data
      }).catch((err) => {
        return {error: err.response}
      });
      const isUserNotFound = Boolean(response.error?.data?.[0]?.message === "Пользователь с таким номером телефона не найден");
      if (isUserNotFound) {
        await this._usersRegistration();

        return
      }
      if (response.error?.status === 500 || !response) {
        this.$toast.error("Ошибка сервера, повторите попытку позднее.");
        return
      }
      if (response.error?.data?.[0]?.message) {
        this.$toast.error(response.error?.data.map((t) => t.message).join("; "));
        return
      }
      if (response.error) {
        this.$toast.error(response.error?.data?.message);
        return
      }

      this.$refs.refPopUpEnterCode.openForm();
      this.$toast.success("Звонок отправлен");
      this.stage = 1;
    },
    _usersRegistration: async function (codeRecaptcha = '') {
      const body = {
        name: String(parseInt(this.form.userInfo.payerPhone.replace(/[^\d]/g, ''))),
        phone: parseInt(this.form.userInfo.payerPhone.replace(/[^\d]/g, ''))
      };
      if (this.isRecaptcha && !codeRecaptcha) {
        this.methodSendRecaptcha = this._usersRegistration.bind(null);
        return
      }
      if (this.isRecaptcha && codeRecaptcha) {
        this.methodSendRecaptcha = null;
        body['g-recaptcha-response'] = codeRecaptcha;
      }
      const response = await this.$api.agent.transport.post("/users/signup", body).then((res) => {
        return res.data
      }).catch((err) => {
        return {error: err.response}
      });
      if (response.error?.status === 500 || !response) {
        this.$toast.error("Ошибка сервера, повторите попытку позднее.");
        return
      }
      if (response.error?.data?.[0]?.message) {
        this.$toast.error(response.error?.data.map((t) => t.message).join("; "));
        return
      }
      if (response.error) {
        this.$toast.error(response.error?.data?.message);
        return
      }

      this.$refs.refPopUpEnterCode.openForm();
      this.$toast.success("Звонок отправлен");
      this.stage = 1;
      this.isRegistration = true;

      return response
    },
    _usersLogin: async function (codeRecaptcha) {
      const body = {
        "username": parseInt(this.form.userInfo.payerPhone.replace(/[^\d]/g, '')),
        "password": this.form.code
      };
      if (this.isRecaptcha && !codeRecaptcha) {
        this.methodSendRecaptcha = this._usersLogin.bind(null);
        return
      }
      if (this.isRecaptcha && codeRecaptcha) {
        this.methodSendRecaptcha = null;
        body['g-recaptcha-response'] = codeRecaptcha;
      }
      const response = await this.$api.agent.transport.post("/users/login", body).then((res) => {
        return res.data
      }).catch((err) => {
        return {error: err.response}
      });
      if (response.error?.status === 500 || !response) {
        this.$toast.error("Ошибка сервера, повторите попытку позднее.");
        return
      }
      if (response.error?.data?.[0]?.message) {
        this.$toast.error(response.error?.data.map((t) => t.message).join("; "));
        return
      }
      if (response.error) {
        this.$toast.error(response.error?.data?.message);
        return
      }

      await this.successAuthRegistration(response);
    },
    _usersConfirmPhone: async function (codeRecaptcha = '') {
      const body = {
        "phone": parseInt(this.form.userInfo.payerPhone.replace(/[^\d]/g, '')),
        "token": this.form.code
      }
      if (this.isRecaptcha && !codeRecaptcha) {
        this.methodSendRecaptcha = this._usersConfirmPhone.bind(null);
        return
      }
      if (this.isRecaptcha && codeRecaptcha) {
        this.methodSendRecaptcha = null;
        body['g-recaptcha-response'] = codeRecaptcha;
      }
      const response = await this.$api.agent.transport.post("/users/confirm/phone", body).then((res) => {
        return res.data
      }).catch((err) => {
        return {error: err.response}
      });
      if (response.error?.status === 500 || !response) {
        this.$toast.error("Ошибка сервера, повторите попытку позднее.");
        return
      }
      if (response.error?.data?.[0]?.message) {
        this.$toast.error(response.error?.data.map((t) => t.message).join("; "));
        return
      }
      if (response.error) {
        this.$toast.error(response.error?.data?.message);
        return
      }

      await this.successAuthRegistration(response);
    },
    successAuthRegistration: async function (response) {
      const token = response?.token;

      // Установка токена в куки
      this.$store.dispatch("userAuth/setToken", {
        authToken: token
      });
      const cookiesOpt = this.$getCookiesOpt({
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 5))
      })
      this.$cookies.set('authToken', token, cookiesOpt);
      await this.$store.dispatch("mindbox/usersAuth");

      // Получение пользователя
      await this.$store.dispatch("user/getUser", {
        expanded: true
      });

      this.stage = 2;

      await this.createOrderCertificate();
    },
    popUpEnterCodeSetCode: async function (value) {
      this.form.code = value;
      await this.createOrderCertificate();
      this.$refs.refPopUpEnterCode.closeForm();
    }
  }
}
